import { commitMutation, graphql } from 'react-relay';
import environment from '../../.';
import { onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation UpdateWidgetMutation($widget: WidgetInput!, $documentId: ID, $historyEntries: [DocumentHistoryEntryInput!]) {
    updateWidget(widget: $widget, documentId: $documentId, historyEntries: $historyEntries) {
      ok
      error
      widgetId
    }
  }
`;

export default ({ widget, documentId, historyEntries }, done) => {
  const variables = {
    widget, documentId, historyEntries 
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ updateWidget }) => {
        const { ok, error, widgetId } = updateWidget;
        done(ok, error, widgetId);
      },
      onError: error => onErrorMutation(error, done)
    }
  );
};
